import axios from 'axios/index'

const baseDomain = 'https://public-api.wordpress.com'
const blogURL = 'roosterpost.wordpress.com'
const baseURL = `${baseDomain}/wp/v2/sites/${blogURL}`

const api = axios.create({
    baseURL,
})

api.interceptors.response.use(
    (response) => response,
    (error) => {
        debugger
        // whatever you want to do with the error
        let {response} = error

        throw new Error(
            response.data.code === 'rest_post_invalid_page_number'
                ? 'no-more'
                : error
        )
    })

export default api


/*
const sendReq = ({ method, subUrl, data }) => {
    return new Promise((resolve, reject) => {
        axios({
            method,
            url: `${baseURI}${subUrl}`,
            data
        })
            .then(res =>
                res.data.status == "success" ? resolve(res.data.data) : reject("Failed")
            )
            .catch(err => reject(`Error in Query ${err}`));
    });
};
*/